/**
 * O contribuinte da linha da lista, na consulta das rotas do detalhe (SPEC-011). A mesma chave pode estar gravada
 * para o prestador e para o tomador do mesmo gestor; com ele, o detalhe é o da linha clicada. Não amplia acesso:
 * quem confere o vínculo é a API. Letras ficam, por causa do CNPJ alfanumérico.
 */
export function consultaDoContribuinte(cnpjContribuinte?: string | null): string {
  const limpo = (cnpjContribuinte ?? '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
  return limpo ? `?cnpjContribuinte=${encodeURIComponent(limpo)}` : '';
}
